module.exports = __webpack_public_path__ + "img/1w.e6120049.svg";